// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1425) return "static/chunks/2170a4aa-af37dc274051e1c4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "aa06879c0773525b" + ".js";
};